import {Action} from '@ngrx/store';
import {
  AddCompanyCommand,
  AddDashboardCommand,
  AddSolutionCommand,
  AddUserCommand, CloneUserCommand, CreateSupportTicketForUserCommand, SendConfirmationEmailCommand,
  SendPasswordCommand,
  UpdateCompanyCommand, UpdateSolutionCommand,
  UpdateUserCommand, UpdateUserNoteCommand
} from '../../commands/admin-panel.command';
import {ProductModel} from '../../models/product.model';
import {CompanyModel} from '../../models/company.model';


export const ADD_USER = '[Users] ADD_USER';
export const ADD_USER_FAILED = '[Users] ADD_USER_FAILED';
export const ADD_USER_SUCCESS = '[Users] ADD_USER_SUCCESS';

export const UPDATE_USER = '[Users] UPDATE_USER';
export const UPDATE_USER_FAILED = '[Users] UPDATE_USER_FAILED';
export const UPDATE_USER_SUCCESS = '[Users] UPDATE_USER_SUCCESS';

export const ADD_DASHBOARD = '[Users] ADD_DASHBOARD';
export const ADD_DASHBOARD_FAILED = '[Users] ADD_DASHBOARD_FAILED';
export const ADD_DASHBOARD_SUCCESS = '[Users] ADD_DASHBOARD_SUCCESS';

export const GET_ALL_PRODUCTS = '[Users] GET_ALL_PRODUCTS';
export const GET_ALL_PRODUCTS_FAILED = '[Users] GET_ALL_PRODUCTS_FAILED';
export const GET_ALL_PRODUCTS_SUCCESS = '[Users] GET_ALL_PRODUCTS_SUCCESS';

export const GET_NON_LICENSED_SOLUTIONS = '[Users] GET_NON_LICENSED_SOLUTIONS';
export const GET_NON_LICENSED_SOLUTIONS_FAILED = '[Users] GET_NON_LICENSED_SOLUTIONS_FAILED';
export const GET_NON_LICENSED_SOLUTIONS_SUCCESS = '[Users] GET_NON_LICENSED_SOLUTIONS_SUCCESS';

export const ADD_COMPANY = '[Users] ADD_COMPANY';
export const ADD_COMPANY_FAILED = '[Users] ADD_COMPANY_FAILED';
export const ADD_COMPANY_SUCCESS = '[Users] ADD_COMPANY_SUCCESS';

export const UPDATE_COMPANY = '[Users] UPDATE_COMPANY';
export const UPDATE_COMPANY_FAILED = '[Users] UPDATE_COMPANY_FAILED';
export const UPDATE_COMPANY_SUCCESS = '[Users] UPDATE_COMPANY_SUCCESS';

export const ADD_SOLUTION = '[Users] ADD_SOLUTION';
export const ADD_SOLUTION_FAILED = '[Users] ADD_SOLUTION_FAILED';
export const ADD_SOLUTION_SUCCESS = '[Users] ADD_SOLUTION_SUCCESS';

export const UPDATE_SOLUTION = '[Users] UPDATE_SOLUTION';
export const UPDATE_SOLUTION_FAILED = '[Users] UPDATE_SOLUTION_FAILED';
export const UPDATE_SOLUTION_SUCCESS = '[Users] UPDATE_SOLUTION_SUCCESS';

export const GET_ALL_COMPANIES = '[Users] GET_ALL_COMPANIES';
export const GET_ALL_COMPANIES_FAILED = '[Users] GET_ALL_COMPANIES_FAILED';
export const GET_ALL_COMPANIES_SUCCESS = '[Users] GET_ALL_COMPANIES_SUCCESS';

export const GET_USER_DETAIL = '[Users] GET_USER_DETAIL';
export const GET_USER_DETAIL_FAILED = '[Users] GET_USER_DETAIL_FAILED';
export const GET_USER_DETAIL_SUCCESS = '[Users] GET_USER_DETAIL_SUCCESS';

export const GET_COMPANY_DETAIL = '[Users] GET_COMPANY_DETAIL';
export const GET_COMPANY_DETAIL_FAILED = '[Users] GET_COMPANY_DETAIL_FAILED';
export const GET_COMPANY_DETAIL_SUCCESS = '[Users] GET_COMPANY_DETAIL_SUCCESS';

export const SEND_CONFIRMATION_EMAIL = '[Users] SEND_CONFIRMATION_EMAIL';
export const SEND_CONFIRMATION_EMAIL_FAILED = '[Users] SEND_CONFIRMATION_EMAIL_FAILED';
export const SEND_CONFIRMATION_EMAIL_SUCCESS = '[Users] SEND_CONFIRMATION_EMAIL_SUCCESS';

export const CLONE_USER = '[Users] CLONE_USER';
export const CLONE_USER_FAILED = '[Users] CLONE_USER_FAILED';
export const CLONE_USER_SUCCESS = '[Users] CLONE_USER_SUCCESS';

export const GET_USER_NOTE = '[Users] GET_USER_NOTE';
export const GET_USER_NOTE_FAILED = '[Users] GET_USER_NOTE_FAILED';
export const GET_USER_NOTE_SUCCESS = '[Users] GET_USER_NOTE_SUCCESS';

export const UPDATE_USER_NOTE = '[Users] UPDATE_USER_NOTE';
export const UPDATE_USER_NOTE_FAILED = '[Users] UPDATE_USER_NOTE_FAILED';
export const UPDATE_USER_NOTE_SUCCESS = '[Users] UPDATE_USER_NOTE_SUCCESS';

export const CREATE_SUPPORT_TICKET_FOR_USER = '[Users] CREATE_SUPPORT_TICKET_FOR_USER';
export const CREATE_SUPPORT_TICKET_FOR_USER_FAILED = '[Users] CREATE_SUPPORT_TICKET_FOR_USER_FAILED';
export const CREATE_SUPPORT_TICKET_FOR_USER_SUCCESS = '[Users] CREATE_SUPPORT_TICKET_FOR_USER_SUCCESS';

export const SEND_PASSWORD = '[Users] SEND_PASSWORD';
export const SEND_PASSWORD_FAILED = '[Users] SEND_PASSWORD_FAILED';
export const SEND_PASSWORD_SUCCESS = '[Users] SEND_PASSWORD_SUCCESS';


export class AddUserAction implements Action {
  readonly type = ADD_USER;

  constructor(public command: AddUserCommand) {
  }
}

export class AddUserFailedAction implements Action {
  readonly type = ADD_USER_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class AddUserSuccessAction implements Action {
  readonly type = ADD_USER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class UpdateUserAction implements Action {
  readonly type = UPDATE_USER;

  constructor(public command: UpdateUserCommand) {
  }
}

export class UpdateUserFailedAction implements Action {
  readonly type = UPDATE_USER_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class UpdateUserSuccessAction implements Action {
  readonly type = UPDATE_USER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddDashboardAction implements Action {
  readonly type = ADD_DASHBOARD;

  constructor(public command: AddDashboardCommand) {
  }
}

export class AddDashboardFailedAction implements Action {
  readonly type = ADD_DASHBOARD_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class AddDashboardSuccessAction implements Action {
  readonly type = ADD_DASHBOARD_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllProductsAction implements Action {
  readonly type = GET_ALL_PRODUCTS;

  constructor() {
  }
}

export class GetAllProductsFailedAction implements Action {
  readonly type = GET_ALL_PRODUCTS_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetAllProductsSuccessAction implements Action {
  readonly type = GET_ALL_PRODUCTS_SUCCESS;

  constructor(public payload: ProductModel[]) {
  }
}

export class GetNonLicensedSolutionsAction implements Action {
  readonly type = GET_NON_LICENSED_SOLUTIONS;

  constructor(public userName: string, public productCode: string) {
  }
}

export class GetNonLicensedSolutionsFailedAction implements Action {
  readonly type = GET_NON_LICENSED_SOLUTIONS_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetNonLicensedSolutionsSuccessAction implements Action {
  readonly type = GET_NON_LICENSED_SOLUTIONS_SUCCESS;

  constructor(public payload: any[]) {
  }
}

export class AddCompanyAction implements Action {
  readonly type = ADD_COMPANY;

  constructor(public command: AddCompanyCommand) {
  }
}

export class AddCompanyFailedAction implements Action {
  readonly type = ADD_COMPANY_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class AddCompanySuccessAction implements Action {
  readonly type = ADD_COMPANY_SUCCESS;

  constructor(public payload: CompanyModel) {
  }
}

export class UpdateCompanyAction implements Action {
  readonly type = UPDATE_COMPANY;

  constructor(public command: UpdateCompanyCommand,
              public sourceType: string) {
  }
}

export class UpdateCompanyFailedAction implements Action {
  readonly type = UPDATE_COMPANY_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class UpdateCompanySuccessAction implements Action {
  readonly type = UPDATE_COMPANY_SUCCESS;

  constructor(public payload: CompanyModel,
              public sourceType: string) {
  }
}

export class AddSolutionAction implements Action {
  readonly type = ADD_SOLUTION;

  constructor(public command: AddSolutionCommand) {
  }
}

export class AddSolutionFailedAction implements Action {
  readonly type = ADD_SOLUTION_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class AddSolutionSuccessAction implements Action {
  readonly type = ADD_SOLUTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class UpdateSolutionAction implements Action {
  readonly type = UPDATE_SOLUTION;

  constructor(public command: UpdateSolutionCommand) {
  }
}

export class UpdateSolutionFailedAction implements Action {
  readonly type = UPDATE_SOLUTION_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class UpdateSolutionSuccessAction implements Action {
  readonly type = UPDATE_SOLUTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllCompaniesAction implements Action {
 readonly type = GET_ALL_COMPANIES;

 constructor() {
 }
}

export class GetAllCompaniesFailedAction implements Action {
  readonly type = GET_ALL_COMPANIES_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetAllCompaniesSuccessAction implements Action {
  readonly type = GET_ALL_COMPANIES_SUCCESS;

  constructor(public payload: CompanyModel[]) {
  }
}


export class GetUserDetailAction implements Action {
  readonly type = GET_USER_DETAIL;

  constructor(public userName: any) {
  }
}

export class GetUserDetailFailedAction implements Action {
  readonly type = GET_USER_DETAIL_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetUserDetailSuccessAction implements Action {
  readonly type = GET_USER_DETAIL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetCompanyDetailAction implements Action {
  readonly type = GET_COMPANY_DETAIL;

  constructor(public companyId: any) {
  }
}

export class GetCompanyDetailFailedAction implements Action {
  readonly type = GET_COMPANY_DETAIL_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetCompanyDetailSuccessAction implements Action {
  readonly type = GET_COMPANY_DETAIL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class SendConfirmationEmailAction implements Action {
  readonly type = SEND_CONFIRMATION_EMAIL;

  constructor(public command: SendConfirmationEmailCommand) {
  }
}

export class SendConfirmationEmailFailedAction implements Action {
  readonly type = SEND_CONFIRMATION_EMAIL_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class SendConfirmationEmailSuccessAction implements Action {
  readonly type = SEND_CONFIRMATION_EMAIL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CloneUserAction implements Action {
  readonly type = CLONE_USER;

  constructor(public command: CloneUserCommand) {
  }
}

export class CloneUserFailedAction implements Action {
  readonly type = CLONE_USER_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class CloneUserSuccessAction implements Action {
  readonly type = CLONE_USER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetUserNoteAction implements Action {
  readonly type = GET_USER_NOTE;

  constructor(public userName: any) {
  }
}

export class GetUserNoteFailedAction implements Action {
  readonly type = GET_USER_NOTE_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class GetUserNoteSuccessAction implements Action {
  readonly type = GET_USER_NOTE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class UpdateUserNoteAction implements Action {
  readonly type = UPDATE_USER_NOTE;

  constructor(public command: UpdateUserNoteCommand) {
  }
}

export class UpdateUserNoteFailedAction implements Action {
  readonly type = UPDATE_USER_NOTE_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class UpdateUserNoteSuccessAction implements Action {
  readonly type = UPDATE_USER_NOTE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CreateSupportTicketForUserAction implements Action {
  readonly type = CREATE_SUPPORT_TICKET_FOR_USER;

  constructor(public command: CreateSupportTicketForUserCommand) {
  }
}

export class CreateSupportTicketForUserFailedAction implements Action {
  readonly type = CREATE_SUPPORT_TICKET_FOR_USER_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class CreateSupportTicketForUserSuccessAction implements Action {
  readonly type = CREATE_SUPPORT_TICKET_FOR_USER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class SendPasswordAction implements Action {
  readonly type = SEND_PASSWORD;

  constructor(public command: SendPasswordCommand) {
  }
}

export class SendPasswordFailedAction implements Action {
  readonly type = SEND_PASSWORD_FAILED;

  constructor(public payload: any) {
    console.error(payload);
  }
}

export class SendPasswordSuccessAction implements Action {
  readonly type = SEND_PASSWORD_SUCCESS;

  constructor(public payload: any) {
  }
}

export type AdminPanelActions = AddUserAction
  | AddUserFailedAction
  | AddUserSuccessAction
  | UpdateUserAction
  | UpdateUserFailedAction
  | UpdateUserSuccessAction
  | AddDashboardAction
  | AddDashboardFailedAction
  | AddDashboardSuccessAction
  | GetAllProductsAction
  | GetAllProductsFailedAction
  | GetAllProductsSuccessAction
  | GetNonLicensedSolutionsAction
  | GetNonLicensedSolutionsFailedAction
  | GetNonLicensedSolutionsSuccessAction
  | AddCompanyAction
  | AddCompanyFailedAction
  | AddCompanySuccessAction
  | UpdateCompanyAction
  | UpdateCompanyFailedAction
  | UpdateCompanySuccessAction
  | AddSolutionAction
  | AddSolutionFailedAction
  | AddSolutionSuccessAction
  | UpdateSolutionAction
  | UpdateSolutionFailedAction
  | UpdateSolutionSuccessAction
  | GetAllCompaniesAction
  | GetAllCompaniesFailedAction
  | GetAllCompaniesSuccessAction
  | GetUserDetailAction
  | GetUserDetailFailedAction
  | GetUserDetailSuccessAction
  | GetCompanyDetailAction
  | GetCompanyDetailFailedAction
  | GetCompanyDetailSuccessAction
  | SendConfirmationEmailAction
  | SendConfirmationEmailFailedAction
  | SendConfirmationEmailSuccessAction
  | GetUserNoteAction
  | GetUserNoteFailedAction
  | GetUserNoteSuccessAction
  | UpdateUserNoteAction
  | UpdateUserNoteFailedAction
  | UpdateUserNoteSuccessAction
  | CreateSupportTicketForUserAction
  | CreateSupportTicketForUserFailedAction
  | CreateSupportTicketForUserSuccessAction
  | SendPasswordAction
  | SendPasswordFailedAction
  | SendPasswordSuccessAction;
